<template>
  <div class="section section__company">
    <div class="section__wrapper">
      <div class="title-with-icon title-with-icon_menu mb-5">
        <div class="title-with-icon__icon title-with-icon__icon_back"></div>
        <div class="title-with-icon__title"><a href="/sveden">Сведения об образовательной организации</a></div>
        <div class="title-with-icon__delimeter">/</div>
        <div class="title-with-icon__title">Международное сотрудничество</div>
      </div>

      <div class="mb-md-12">
        <div class="content_18">
          <h3>О заключенных и планируемых к заключению договорах с иностранными и (или) международными организациями по вопросам образования и науки (при наличии)</h3>
          <p>отсутствует/не применимо</p>
          <h3>О международной аккредитации образовательных программ (при наличии)</h3>
          <p>отсутствует/не применимо</p>
        </div>
      </div>

      <div class="my-5 d-block d-md-none">
        <a class="history-back" href="/sveden">Вернуться</a>
      </div>

      <div class="section__subsection_blue section__company-nav">
        <div class="section__subsection-wrapper">
          <company-navigation/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyNavigation from "../../components/CompanyNavigation";
export default {
  name: "InfoVacancy",
  components: {CompanyNavigation},
  mounted() {
    this.$parent.init()
  }
}
</script>
<style lang="scss">
  .content_18 {
    h3 {
      font-size: 22px;
      font-weight: 500;
      margin-top: 20px;
    }
  }
</style>